// Stesso spinner di ProtectedRoute: durante il download di una pagina l'utente
// vede lo stesso indicatore dell'attesa della sessione, non un passaggio nuovo.
export default function RouteSpinner({ fill = "min-h-dvh" }) {
  return (
    <div className={`${fill} flex items-center justify-center`} data-testid="route-loading">
      <div className="inline-block h-10 w-10 border-2 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
